import { ListChecks } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";

// Champs affichés en premier dans la fiche, selon le type de prospect de chaque pipeline
export function FieldProfilesSection() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/settings/field-profiles").then(({ data: d }) => setData(d)).catch(() => setData(false)); }, []);
  if (!data) return null;
  const save = async (patch) => {
    const body = { pipelines: data.pipelines, profiles: Object.fromEntries(Object.entries(data.profiles).map(([k, v]) => [k, v.fields])), ...patch };
    try { setData((await api.put("/settings/field-profiles", body)).data); toast.success("Champs de la fiche enregistrés."); } catch (e) { toast.error(e?.response?.data?.detail || "Erreur, réessayez."); }
  };
  const toggle = (id, name) => {
    const cur = data.profiles[id].fields;
    const next = cur.includes(name) ? cur.filter((n) => n !== name) : [...cur, name];
    save({ profiles: { ...Object.fromEntries(Object.entries(data.profiles).map(([k, v]) => [k, v.fields])), [id]: next } });
  };
  return (
    <section className="settings-section" data-testid="field-profiles-section">
      <div className="section-title"><ListChecks size={20} /><div><p className="eyebrow">FICHE OPPORTUNITÉ</p><h2>Champs utiles par pipeline</h2></div></div>
      <p className="fileprep-dedup-hint">Chaque fiche affiche d'abord les champs de son type de prospect ; les autres restent repliés dans « Autres champs ». « Automatique » : mairie si le nom commence par Mairie/Commune, immeuble si le script parle d'immeuble ou d'appartements, entreprise si le tag B2B est posé, sinon particulier.</p>
      <div className="fp-profiles">
        {Object.entries(data.profiles).map(([id, p]) => (
          <div key={id} className="fp-profile" data-testid={`field-profile-${id}`}>
            <button type="button" className="pls-name" onClick={() => setOpen(open === id ? null : id)} data-testid={`field-profile-open-${id}`}>{p.label} <small>{p.fields.length} champs</small></button>
            <p className="fp-list">{p.fields.join(" · ")}</p>
            {open === id && <div className="pls-steps">{data.field_names.map((n) => <button key={n} type="button" className={`rc-chip${p.fields.includes(n) ? " on" : ""}`} onClick={() => toggle(id, n)} data-testid={`field-profile-${id}-${n.replace(/\W+/g, "-")}`}>{n}</button>)}</div>}
          </div>
        ))}
      </div>
      <div className="fp-map">
        {data.pipeline_names.map((name, i) => (
          <label key={name}>{name}
            <select className="pl-select" value={data.pipelines[name] || ""} onChange={(e) => save({ pipelines: { ...data.pipelines, [name]: e.target.value } })} data-testid={`field-profile-pipeline-${i}`}>
              <option value="">Automatique</option>
              {Object.entries(data.profiles).map(([id, p]) => <option key={id} value={id}>{p.label}</option>)}
            </select>
          </label>
        ))}
      </div>
    </section>
  );
}
